/* SPDX-License-Identifier: AGPL-3.0-or-later */

import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class Globals {
    readonly backendUri: string = this.findBackendUrl();
    readonly mainTournamentId: number = this.getMainTournamentId();
    readonly mainTournamentToken: string = this.getMainTournamentToken();

    private findBackendUrl(): string {
        if (window.location.port === '4200') {
            // local `ng serve`, backend at localhost:8080
            return 'http://localhost:8080/api/v1';
        } else {
            // assume deployed somewhere and backend is available at same host/port as frontend
            return 'https://beerbrawl-pfeilheim-d38ccafb9f48.herokuapp.com/api/v1';
        }
    }

    private getMainTournamentToken(): string {
        if (window.location.port === '4200') {
            // local `ng serve`, backend at localhost:8080
            return 'f5cc5e64-388f-449b-891d-6e2885303a16';
        } else {
            // assume deployed somewhere and backend is available at same host/port as frontend
            return '85e3e967-812d-462b-a36c-ddecf6e9420d';
        }
    }

    private getMainTournamentId(): number {
        if (window.location.port === '4200') {
            return 32;
        } else {
            return 1;
        }
    }
}
